import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
//Servicios
import { AuthService } from '../../services/auth.service';
//Constantes generales
import * as AppConst from '../../constants/app.const';
import { StatsService } from '../../services/stats.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css']
})
export class NavBarComponent implements OnInit {

  version: string = "";
  userName: string = "";

  constructor(
    private router: Router,
    public authService: AuthService,
    private statsService: StatsService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.version = AppConst.VERSION;
    this.userName = this.authService.currentUserValue.name;
  }

  ClickLogOut() {
    const userId: string = this.authService.currentUserValue.email;

    this.authService.QuitarDocumentosAsignados(userId).subscribe(quitado => {
      this.authService.Logout();
      this.router.navigate(['/Login']);
    }, error => {
      console.log(error);
    });
  }

  generarExcelPendientes() {

    this.statsService.generarExcelDocsPendientes()
      .subscribe(resultado => {
        this.toastr.success("Excel generado. Descargando...");

        let dataType = resultado.type;
        let binaryData = [];
        binaryData.push(resultado);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
        downloadLink.setAttribute('download', "DocumentosPendientesProcesado");
        document.body.appendChild(downloadLink);
        downloadLink.click();

      }, error => {
        console.log(error);
        this.toastr.error("No se ha podido generar el documento excel");
      });
  }

}
